import { render } from "./PriceGroupItemForm.vue?vue&type=template&id=302d7b40"
import script from "./PriceGroupItemForm.vue?vue&type=script&lang=js"
export * from "./PriceGroupItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__